// @flow

/* eslint-disable ta-code-conventions/has-matching-test */
import * as React from 'react';
import Skeleton from '@ta/styleguide.skeleton';
import styles from './ProfileCardLoadingSkeleton.less';

const ProfileCardLoadingSkeleton = () => (
  <div className={`${styles.loading_container} ui_columns`}>
    <div className={`${styles.circle_container} ui_skeleton ui_column`}>
      <div className={styles.circle} />
    </div>
    <div className={`${styles.skeleton_container} ui_column`}>
      <Skeleton height="18px" marginBottom="4px" />
      <Skeleton height="14px" />
    </div>
  </div>
);

export default ProfileCardLoadingSkeleton;
